interface Rect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * Returns the visible bounding rect for an element, robust to wrappers
 * that use `display: contents`. Such wrappers have no box of their own
 * but the content they enclose still paints — `Range.getBoundingClientRect`
 * yields the union of the rendered content (including text nodes), which
 * is what we want for both Inspector highlight frames and UI Designer
 * geometry reports.
 */
const getEffectiveRect = (el: Element): Rect => {
  let { left, top, width, height } = el.getBoundingClientRect();

  if (width === 0 && height === 0 && el.ownerDocument) {
    const range = el.ownerDocument.createRange();
    range.selectNodeContents(el);
    const contentRect = range.getBoundingClientRect();
    if (contentRect) {
      left = contentRect.left;
      top = contentRect.top;
      width = contentRect.width;
      height = contentRect.height;
    }
  }

  return { left, top, width, height };
};

export default getEffectiveRect;
